import {Page} from 'utils/page-utils';
import SearchTracking from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import getFilters from '../utils/filters';
import getParkingType from '../utils/parking-type';
import getFilteredSearchResults from '../utils/filtered-search-results';

export default function trackMapAdjusted({
    actionType,
    city,
    filters,
    sortBy,
    isMonthly,
    pageType,
    spots,
    mapCenter,
    mapBounds,
}) {
    const isEvent = pageType === Page.EVENT;
    const isAirport = pageType === Page.AIRPORT;
    const isEventPackage = pageType === Page.EVENT_PACKAGES_SEARCH;
    const {searchUUID, actionUUID} = SearchTracking.getValues();
    const filteredSpots = getFilteredSearchResults({
        filters,
        spots,
        isMonthly,
        sortBy,
    });
    const properties = {
        action_id: actionUUID,
        action_type: actionType,
        availability_check: actionType !== 'ZOOM_IN',
        city,
        filters: getFilters(filters),
        map_center: {
            latitude: mapCenter.latitude,
            longitude: mapCenter.longitude,
        },
        map_coordinates: {
            northeast: {
                latitude: mapBounds.northEast.latitude,
                longitude: mapBounds.northEast.longitude,
            },
            southwest: {
                latitude: mapBounds.southWest.latitude,
                longitude: mapBounds.southWest.longitude,
            },
        },
        parking_type: getParkingType({
            isMonthly,
            isAirport,
            isEvent,
            isEventPackage,
        }),
        search_id: searchUUID,
        top_search_results_list: filteredSpots.map(({spotId, tag}) => {
            return {
                facility_id: spotId,
                tag,
            };
        }),
    };

    SegmentUtils.track({
        event: 'Map Adjusted',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
